(function(context) {
    let version = {
        "TWO": "2.1",
        "THREE": "3.0",
        "FOUR": "4.0"
    }

    let vCard = {
        Version: version,
        Entry: {
            "ADDRESS": {"version": [version.TWO, version.THREE, version.FOUR], "key": "ADR;CHARSET=UTF-8", "format": ";;{0};{2};{4};{1};{3}", "@comment": "usage: addAdr(street, code, city, country, state)"},
            "AGENT": {"version": [version.TWO, version.THREE], "key": "AGENT;CHARSET=UTF-8"},
            "ANNIVERSARY": {"version": [version.FOUR], "key": "ANNIVERSARY;CHARSET=UTF-8"},
            "BIRTHDAY": {"version": [version.TWO, version.THREE, version.FOUR], "key": "BDAY"},
            "CALENDARADDURI": {"version": [version.FOUR], "key": "CALADRURI"},
            "CALENDARURI": {"version": [version.FOUR], "key": "CALURI"},
            "CATEGORIES": {"version": [version.TWO, version.THREE, version.FOUR], "key": "CATEGORIES;CHARSET=UTF-8"},
            "CLASS": {"version": [version.THREE], "key": "CLASS"},
            "CLIENTPIDMAP": {"version": [version.FOUR], "key": "CLIENTPIDMAP"},
            "EMAIL": {"version": [version.TWO, version.THREE, version.FOUR], "key": "EMAIL"},
            "FBURL": {"version": [version.FOUR], "key": "FBURL"},
            "FORMATTEDNAME": {"version": [version.TWO, version.THREE, version.FOUR], "key": "FN;CHARSET=UTF-8"},
            "GENDER": {"version": [version.FOUR], "key": "GENDER"},
            "GEO": {"version": [version.TWO, version.THREE, version.FOUR], "key": "GEO"}, // FIXME two differents formats
            "IMPP": {"version": [version.THREE, version.FOUR], "key": "IMPP"},
            // TODO: KEY
            "KIND": {"version": [version.FOUR], "key": "KIND"},
            "LABEL": {"version": [version.TWO, version.THREE], "key": "LABEL;CHARSET=UTF-8"},
            // TODO: LOGO
            "MAILER": {"version": [version.TWO, version.THREE], "key": "MAILER"},
            "MEMBER": {"version": [version.FOUR], "key": "MEMBER;CHARSET=UTF-8"},
            "NAME": {"version": [version.TWO, version.THREE, version.FOUR], "key": "N;CHARSET=UTF-8", "format": "{1};{0};;{2}", "@comment": "usage: addName(firstname, lastname, title)"},
            "NICKNAME": {"version": [version.THREE, version.FOUR], "key": "NICKNAME;CHARSET=UTF-8"},
            "NOTE": {"version": [version.TWO, version.THREE, version.FOUR], "key": "NOTE;CHARSET=UTF-8"},
            "ORGANIZATION": {"version": [version.TWO, version.THREE, version.FOUR], "key": "ORG;CHARSET=UTF-8"},
            // TODO: PHOTO
            "PRODID": {"version": [version.THREE, version.FOUR], "key": "PRODID;CHARSET=UTF-8"},
            "PROFILE": {"version": [version.TWO, version.THREE], "key": "PROFILE;CHARSET=UTF-8"},
            "RELATED": {"version": [version.FOUR], "key": "RELATED"},
            "REVISION": {"version": [version.TWO, version.THREE, version.FOUR], "key": "REV"},
            "ROLE": {"version": [version.TWO, version.THREE, version.FOUR], "key": "ROLE"},
            "SORTSTRING": {"version": [version.TWO, version.THREE, version.FOUR], "key": "SORT-STRING"},
            // TODO: SOUND
            "SOURCE": {"version": [version.TWO, version.THREE, version.FOUR], "key": "SOURCE"},
            "PHONE": {"version": [version.TWO, version.THREE, version.FOUR], "key": "TEL"},
            "TITLE": {"version": [version.TWO, version.THREE, version.FOUR], "key": "TITLE;CHARSET=UTF-8"},
            "TIMEZONE": {"version": [version.TWO, version.THREE, version.FOUR], "key": "TZ"}, // FIXME: two differents formats
            "UID": {"version": [version.TWO, version.THREE, version.FOUR], "key": "UID"},
            "URL": {"version": [version.TWO, version.THREE, version.FOUR], "key": "URL;CHARSET=UTF-8"},
            "XML": {"version": [version.FOUR], "key": "XML"}
        },
        Type: {
            "HOME": "HOME",
            "WORK": "WORK",
            "CELL": "CELL",
            "MAIN": "MAIN",
            "OTHER":"OTHER"
        },
        create: function(version) {
            for(let key in this.Version) {
                if(this.Version[key] === version)
                    return new Card(version)
            }
            throw new Error("Unknown vCard version")
        },
        dump: function(card) {
            let str = "BEGIN:VCARD\n"

            for(let key in card) {
                let entry = card[key]

                if(typeof entry === "function")
                    continue

                if(Object.prototype.toString.call(entry) === "[object Array]") {
                    for(let i = 0, l = entry.length; i < l; i++) {
                        let e = entry[i]
                        str += key.toUpperCase() + (e.type ? ";TYPE=" + e.type.toUpperCase() + ":" : ":") + e.value + "\n"
                    }
                } else if(typeof entry === "object") {
                    str += key.toUpperCase() + (entry.type ? ";TYPE=" + entry.type.toUpperCase() + ":" : ":") + entry.value + "\n"
                } else {
                    str += key.toUpperCase() + ":" + entry + "\n"
                }
            }

            str += "END:VCARD"

            return str
        },
        export: function(card, name, force) {
            let a = document.createElement('a')
            a.download = name + ".vcf"
            a.textContent = name

            if(Blob) {
                let blob = new Blob([this.dump(card)], {"type": "text/vcard"})
                a.href = URL.createObjectURL(blob)
            } else {
                a.href = "data:text/vcard;base64," + this.btoa(this.dump(card))
            }

            force && a.click()

            return a
        },
        btoa: function(str) {
            str = unescape(encodeURIComponent(str))

            if(!btoa) {
                let b64c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя";

                let i, res = "", length = str.length;
                for (i = 0; i < length - 2; i += 3) {
                    res += b64c[str.charCodeAt(i) >>> 2];
                    res += b64c[((str.charCodeAt(i) & 3) << 4) | (str.charCodeAt(i + 1) >>> 4)];
                    res += b64c[((str.charCodeAt(i + 1) & 15) << 2) | (str.charCodeAt(i + 2) >>> 6)];
                    res += b64c[str.charCodeAt(i + 2) & 63];
                }
    
                if (length % 3 === 2) {
                    res += b64c[str.charCodeAt(i) >>> 2];
                    res += b64c[((str.charCodeAt(i) & 3) << 4) | (str.charCodeAt(i + 1) >>> 4)];
                    res += b64c[((str.charCodeAt(i + 1) & 15) << 2)];
                    res += "=";
                } else if (length % 3 === 1) {
                    res += b64c[str.charCodeAt(i) >>> 2];
                    res += b64c[((str.charCodeAt(i) & 3) << 4)];
                    res += "==";
                }

                return res;
            } else {
                return btoa(str)
            }
        }
    }

    let Card = function(version) {
        this.version = version

        for(let key in vCard.Entry) {
            let property = vCard.Entry[key]

            if(!property.version || property.version.indexOf(version) < 0)
                continue

            let fn = "add" + key[0].toUpperCase() + key.slice(1).toLowerCase()

            Card.prototype[fn] = (function(key, format) {
                return (function() {
                    let args = Array.prototype.slice.call(arguments)
                    let lastArg = args.length > 0 ? args[args.length - 1] : undefined

                    let model = vCard.Type.hasOwnProperty(lastArg) ? args.slice(0, args.length - 1) : args
                    let value = format && format.replace(/\{([0-9]*)\}/g, function(match, parameter) {
                        return model[parseInt(parameter)] || ''
                    }) || model[0]

                    this.add(key, value, vCard.Type.hasOwnProperty(lastArg) && lastArg)
                })
            })(property.key, property.format)
        }

        this.add = function(entry, value, type) {
            let key = (typeof entry === "object" && entry.key) ? entry.key : entry

            !this[key] && (this[key] = [])
            let e = {"value": value}
            type && (e.type = type)

            this[key].push(e)
        }
    }

    context.vCard = vCard
})(this)